export default "__VITE_ASSET__BK51p6NL__"